export interface UserNameParserModel {
  firstName?: string;
  lastName?: string;
}
